module.exports = __webpack_public_path__ + "img/bg-back-qrcode.f174c5f0.png";